var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomFeather = function SvgCustomFeather(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.035 16.063 13 19.161a1.444 1.444 0 0 1-1.026.428H5.969l-2.717 2.722a.732.732 0 1 1-1.037-1.038l2.07-2.068 3.766-3.766h7.724a.366.366 0 0 1 .26.624ZM18.923 4.07c-.892-.887-2.553-2.136-4.008-2.066a5.864 5.864 0 0 0-3.862 1.708L4.629 10.06a1.477 1.477 0 0 0-.322.479 1.652 1.652 0 0 0-.108.635v5.155c0 .039.02.146.059.205.039.059.098.107.166.137.068.029.15.039.215.02a.345.345 0 0 0 .186-.098L15.103 6.307a.733.733 0 0 1 1.036 1.037l-6.621 6.63h8.097a.366.366 0 0 0 .327-.199s.95-.77 1.596-1.578c1.03-1.035 1.913-2.06 1.767-3.804-.146-1.744-1.153-3.09-2.382-4.324Z",
    fill: "currentColor"
  })));
};

export default SvgCustomFeather;